// src/utils/constants.js

// Game state constants
export const GAME_STATE = {
    PLACEMENT: 'placement',
    BATTLE: 'battle',
    PAUSED: 'paused',
    GAME_OVER: 'game_over',
    WAVE_COMPLETE: 'wave_complete'
  };
  
  // Team identifiers
  export const TEAMS = {
    RED: 'red', // Player team
    BLUE: 'blue' // Enemy team
  };
  
  // Battle line positions
  export const BATTLE_LINE = {
    START_POSITION: 50,    // Initial position in percentage
    WIN_THRESHOLD: 95,     // Position needed to win (95% of battlefield)
    LOSE_THRESHOLD: 5      // Position where you lose (5% of battlefield)
  };
  
  // Unit costs for purchasing
  export const UNIT_COSTS = {
    'pawn': 50,     // Fast, cheap melee unit
    'footman': 75,  // Balanced melee unit
    'archer': 150,  // Ranged unit
    'bombardCrew': 250, // Siege unit
    'barrel': 100,  // Kamikaze unit
    'woodtower': 400 // Defensive structure
  };